interface UiConfig {
    ALLOW_FEATURE_BRANCH_TESTING_OPTIONS?: boolean;
    ALLOW_LOCAL_TESTING_OPTIONS?: boolean;
    CHIME_METRICS_URI: string;
    DIRECT_STREAMING_DOMAIN: string;
    LAERDAL_LIFE_ICONS_VERSION?: string;
    SHOW_COMPONENTS?: boolean;
    SIMCAPTURE_UI_COMPONENTS_VERSION?: string;
    SIMCAPTURE_UI_EVALUATIONS_VERSION?: string;
    SOCKET_CLUSTER_URI: string;
    LIVEKIT_WEBSOCKET_URI: string;
    UI_GUDRID_INSTRUCTOR_APP_URL?: string;
}

import UiConfigObject from '../../../ui-config.json' with {type: 'json'};

const uiConfig: UiConfig = UiConfigObject;

export default uiConfig;
